/* eslint-disable react/jsx-indent */
/* eslint-disable no-underscore-dangle */
// eslint-disable-next-line no-use-before-define
import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import nexumLogo from "../../../assets/nexumLogo.png";
import Button from "../../../shared/components/button/button";

class NotAuthorized extends Component {
  render() {
    return (
      <section data-test="signin-wrapper">
        <div className="inner-wrapper login-body">
          <div className="login-wrapper">
            <article className="container">
              <div className="loginbox shadow-sm grow">
                <div className="login-left">
                  <img className="img-fluid" src={nexumLogo} alt="nexumLogo" />
                </div>
                <div>
                  <p>
                    Non sei autorizzato a vedere questa risorsa.
                  </p>
                  <p><a href="/">Vai alla pagina di login</a></p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    );
  }
}

export default NotAuthorized;
